"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (state = [], action) => {
    if (action.type === 'FETCH_DEVICE_USER_INFO_SUCCESS') {
        return [...action.deviceUserInfoSchema];
    }
    return state;
};
const DEVICE_SCHEMA = [
    { keyPath: 'advertisingIdentifier', attributeType: 'STRING' },
    { keyPath: 'appBadgeNumber', attributeType: 'NUMBER' },
    { keyPath: 'appBuild', attributeType: 'STRING' },
    { keyPath: 'appIdentifier', attributeType: 'STRING' },
    { keyPath: 'appVersion', attributeType: 'STRING' },
    { keyPath: 'buildEnvironment', attributeType: 'STRING' },
    { keyPath: 'carrierName', attributeType: 'STRING' },
    { keyPath: 'conversions', attributeType: 'ARRAY_OF_STRINGS' },
    { keyPath: 'deviceIdentifier', attributeType: 'STRING' },
    { keyPath: 'deviceManufacturer', attributeType: 'STRING' },
    { keyPath: 'deviceModel', attributeType: 'STRING' },
    { keyPath: 'deviceName', attributeType: 'STRING' },
    { keyPath: 'isCellularEnabled', attributeType: 'BOOLEAN' },
    { keyPath: 'isDarkModeEnabled', attributeType: 'BOOLEAN' },
    { keyPath: 'isBluetoothEnabled', attributeType: 'BOOLEAN' },
    { keyPath: 'isLocationServicesEnabled', attributeType: 'BOOLEAN' },
    { keyPath: 'isTestDevice', attributeType: 'BOOLEAN' },
    { keyPath: 'isWifiEnabled', attributeType: 'BOOLEAN' },
    { keyPath: 'localeLanguage', attributeType: 'STRING' },
    { keyPath: 'localeRegion', attributeType: 'STRING' },
    { keyPath: 'localeScript', attributeType: 'STRING' },
    { keyPath: 'location.verticalAccuracy', attributeType: 'NUMBER' },
    { keyPath: 'location.horizontalAccuracy', attributeType: 'NUMBER' },
    { keyPath: 'location.coordinate', attributeType: 'ARRAY_OF_NUMBERS' },
    { keyPath: 'location.timestamp', attributeType: 'DATE_TIME' },
    { keyPath: 'location.altitude', attributeType: 'NUMBER' },
    { keyPath: 'location.address.street', attributeType: 'STRING' },
    { keyPath: 'location.address.city', attributeType: 'STRING' },
    { keyPath: 'location.address.country', attributeType: 'STRING' },
    { keyPath: 'location.address.postalCode', attributeType: 'STRING' },
    { keyPath: 'location.address.subLocality', attributeType: 'STRING' },
    {
        keyPath: 'location.address.subAdministrativeArea',
        attributeType: 'STRING',
    },
    { keyPath: 'location.address.state', attributeType: 'STRING' },
    { keyPath: 'location.address.isoCountryCode', attributeType: 'STRING' },
    { keyPath: 'locationAuthorization', attributeType: 'STRING' },
    { keyPath: 'notificationAuthorization', attributeType: 'STRING' },
    { keyPath: 'operatingSystemName', attributeType: 'STRING' },
    { keyPath: 'operatingSystemVersion', attributeType: 'STRING' },
    { keyPath: 'pushToken.value', attributeType: 'STRING' },
    { keyPath: 'pushToken.timestamp', attributeType: 'DATE_TIME' },
    { keyPath: 'radio', attributeType: 'STRING' },
    { keyPath: 'screenHeight', attributeType: 'NUMBER' },
    { keyPath: 'screenWidth', attributeType: 'NUMBER' },
    { keyPath: 'sdkVersion', attributeType: 'STRING' },
    { keyPath: 'timeZone', attributeType: 'STRING' },
];
const TICKETING_DEVICE_SCHEMA = [
    { keyPath: 'tickets.seat', attributeType: 'NUMBER' },
    { keyPath: 'tickets.row', attributeType: 'STRING' },
    { keyPath: 'tickets.section', attributeType: 'STRING' },
    { keyPath: 'tickets.gate', attributeType: 'STRING' },
    { keyPath: 'tickets.eventName', attributeType: 'STRING' },
    { keyPath: 'tickets.planName', attributeType: 'STRING' },
    { keyPath: 'tickets.priceCode', attributeType: 'STRING' },
    { keyPath: 'tickets.ticketTypeCode', attributeType: 'STRING' },
    { keyPath: 'tickets.sectionType', attributeType: 'STRING' },
    { keyPath: 'tickets.compSeat', attributeType: 'STRING' },
    { keyPath: 'tickets.seatType', attributeType: 'STRING' },
    { keyPath: 'tickets.originalOwnerID', attributeType: 'NUMBER' },
];
exports.getDeviceSchema = (state, ticketingEnabled) => {
    const attributes = DEVICE_SCHEMA.concat(state);
    if (ticketingEnabled) {
        return attributes.concat(TICKETING_DEVICE_SCHEMA);
    }
    return attributes;
};
exports.getIsAttributeArrayType = (state, keyPath) => !!exports.getDeviceSchema(state)
    .filter(({ attributeType }) => attributeType.includes('ARRAY'))
    .find((attribute) => attribute.keyPath === keyPath);
